<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" style="margin-right:20px;">
    <span class="cursor-pointer flex items-center i18n-locale">
      <span class="hidden sm:block ml-2">Theme: {{ getCurrent }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item  v-for="(data,index) in theThemes()"  :key="index" @click="updateTheme(data.slug)">{{data.name.split('-')[0]}}</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
// import themes from "@/store/themes/moduleThemes.js"
export default {
  computed: {
    getCurrent() {
        const currentSlug = this.$store.state.themes.current
        const current = this.$store.state.themes.list.find((e) => e.slug === currentSlug)
        const currentName = current ? current.name : ''
        // return this.$store.state.themes.current
        console.log(currentName.split('-')[0]);
        if(currentName){
          return currentName.split('-')[0]
        }else{
          return 'falback'
        }
    },
  },
  methods: {
    updateTheme(theme) {
      this.$store.dispatch('themes/setCurrentTheme', theme)
      // this.$router.go(0)
    },
    theThemes(){
      console.log(this.getCurrent);
      return this.$store.state.themes.list

      // {
      //   {
      //     id: 1,
      //     name: "Brisk - Multi-Purpose Elementor WordPress Theme",
      //     slug: "brisk",
      //     cover: "",
      //     user: 0,
      //     pro: 0
      //     },
      // }
    }
  },
  created() {
    // if(!themes.isRegistered) {
    //   this.$store.registerModule('themes', themes)
    //   themes.isRegistered = true
    // }
    this.$store.dispatch("themes/fetchDataListItems", this.$store.state.themes.current)
  },
}
//openai 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
</script>
